import * as React from 'react';
import "../../Login/Login.css"

import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import { EmailInput, FormInput, FormMaskedTextBox } from "../../../Utils/form-components"
import { Button } from '@progress/kendo-react-buttons';
import { requiredValidator } from '../../../Utils/validators';


export default function BusinessDetails(props) {
    let handleSubmit = async (dataItem) => {
        props.onStepSubmit()
    };
    return (
        <div style={{ display: "flex", justifyContent: "center", margin: "5% 0px 5% 0px" }}>

            <Card className="sign-up-card" style={{
                margin: "10px",
                minWidth: 350
            }}>

                <CardTitle className='card-title'>
                    Register your Business
                </CardTitle>

                <CardBody>
                    <Form onSubmit={handleSubmit} render={formRenderProps => <FormElement >
                        <fieldset className={'k-form-fieldset'}>
                            <FieldWrapper>
                                <Field onChange={(e) => props.onDataChange("BusinessName", e.value)} name={'businessName'} component={FormInput} label={'Business Name'} validator={requiredValidator} />
                                <Field onChange={(e) => props.onDataChange("Address", e.value)} name={'address'} component={FormInput} label={'Address'} /*validator={lastNameValidator}*/ />
                            </FieldWrapper>
                            <FieldWrapper>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>

                                    <Field onChange={(e) => props.onDataChange("City", e.value)} name={'city'} component={FormInput} label={'City'} /*validator={firstNameValidator} */ />
                                    <Field onChange={(e) => props.onDataChange("Province", e.value)} name={'province'} component={FormInput} label={'Province'} /*validator={lastNameValidator}*/ />
                                </div>

                            </FieldWrapper>
                            <FieldWrapper>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>

                                    <Field onChange={(e) => props.onDataChange("PostalCode", e.value)} name={'postalCode'} component={FormInput} label={'Postal Code'} /*validator={firstNameValidator} */ />
                                    <Field onChange={(e) => props.onDataChange("Country", e.value)} name={'country'} component={FormInput} label={'Country'} /*validator={lastNameValidator}*/ />
                                </div>

                            </FieldWrapper>


                            {/* Phone Number*/}
                            <FieldWrapper>
                                <Field onChange={(e) => props.onDataChange("ContactNumber", e.value)} id={'phoneNumber'} name={'phoneNumber'} label={'Business Phone Number'} mask={'(000) 000-0000'} component={FormMaskedTextBox} />
                            </FieldWrapper>

                            {/* Business Email */}
                            {/* <Field onChange={(e) => props.onDataChange("businessEmail", e.value)}  name={"email"} type={"email"} component={EmailInput} label={"Business Email"} /> */}

                            <span className={"k-form-separator"} style={{ margin: "30px 0px 10px 0px" }} />
                            <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                <Button
                                    themeColor={'secondary'}
                                    style={{ marginTop: "25px", width: "45%", padding: "10px 4px 10px 4px" }}
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                    onClick={props.onPrevStepClick}
                                >
                                    Back
                                </Button>
                                <Button
                                    themeColor={'primary'}
                                    type={'submit'}
                                    style={{ marginTop: "25px", minWidth: "45%", padding: "10px 4px 10px 4px" }}
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                    disabled={!formRenderProps.allowSubmit}
                                >
                                    Create Account
                                </Button>
                            </div>

                        </fieldset>
                    </FormElement>} />
                </CardBody>
            </Card>
        </div>

    )
}

